<!-- titles shoudl be embeded in the blog for greater flexibility? -->
<!--h2 *ngIf="pageData && pageData.title" [innerHtml]="pageData.title"> </h2-->

<div #content *ngIf="pageData" [innerHtml]="pageData.content | sanitizer:'html'" [ngClass]="pageType" (click)="contentClicked($event)"></div>

<h3 *ngIf="tiles && tiles.length > 0">
  Recommended Reading
</h3>

<mbnm-navigation-tiles *ngIf="tiles && tiles.length > 0" class="tiles" mode="list" [tileCollection]="tiles"></mbnm-navigation-tiles>

<mat-spinner color="secondary" *ngIf="!pageData || !tiles"></mat-spinner>

<mat-paginator *ngIf="totalTiles" [length]="totalTiles" (page)="pageChanged($event)"
               [pageSize]="postsPerPage">
</mat-paginator>
